import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { useAtomValue } from 'jotai';

import { spontaneousApplyDataAtom } from '../worker-entry-point.atoms';

export const useStepData = () => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      {
        key: 'step-1',
        title: t('onboarding-page:cv_loading.we_are_reading_your_cv'),
        subTitle: t('onboarding-page:cv_loading.the_analysis_of_your_data_is_important'),
        progressLabel: {
          title: t('onboarding-page:cv_loading.on_you'),
          icon: '/utils-assets/single-user.svg',
          remainingTime: `10 sec. ${t('common:remained')}`,
        },
        progressPercent: 25,
      },
      {
        key: 'step-2',
        title: t('onboarding-page:cv_loading.let_take_a_look_at_your_experiences'),
        subTitle: t('onboarding-page:cv_loading.everything_has_its_preparation_time'),
        progressLabel: {
          title: t('common:experiences'),
          icon: '/utils-assets/briefcase.svg',
          remainingTime: `5 sec. ${t('common:remained')}`,
        },
        progressPercent: 50,
      },
      // {
      //   key: 'step-3',
      //   title: t('onboarding-page:cv_loading.lets_see_what_you_studied'),
      //   subTitle: t('onboarding-page:cv_loading.extracting_the_data_from_your_cv'),
      //   progressLabel: {
      //     title: t('common:training'),
      //     icon: '/utils-assets/graduate-hat.svg',
      //     remainingTime: `1 sec. ${t('common:remained')}`,
      //   },
      //   progressPercent: 75,
      // },
      {
        key: 'step-4',
        title: t('onboarding-page:cv_loading.lets_put_the_icing_on_the_cake'),
        subTitle: t('onboarding-page:cv_loading.enter_all_the_data_by_hand'),
        progressLabel: {
          title: t('common:preferences'),
          icon: '/utils-assets/love-sign.svg',
          remainingTime: `1 sec. ${t('common:remained')}`,
        },
        progressPercent: 75,
      },
    ],
    [t]
  ) as CVParsingProps;
};
export const useCompletedStepData = () => {
  const { t } = useTranslation('onboarding-page');
  const spontaneousApplyData = useAtomValue(spontaneousApplyDataAtom);
  const isSpontaneousApplication = spontaneousApplyData?.isSpontaneousEntry;

  return useMemo(
    () => ({
      key: 'complete',
      title: `${t(
        isSpontaneousApplication
          ? 'cv_loading.your_spontaneous_application_has_been_submitted'
          : 'cv_loading.your_cv_has_been_analyzed'
      )} 🚀`,
      subTitle: t(
        isSpontaneousApplication
          ? 'cv_loading.the_selection_process_is_managed_by_the_company_you_applied_to_key'
          : 'cv_loading.check_the_data_collected_and_correct_the_missing_ones'
      ),
      additionalContent: isSpontaneousApplication ? t('cv_loading.make_sure_your_profile_is_fully_up_to_date') : '',
      progressLabel: {
        title: '',
        icon: '',
        remainingTime: '',
      },
      progressPercent: 100,
    }),
    [isSpontaneousApplication, t]
  );
};
export type CVParsingProps = {
  key: string;
  title: string;
  subTitle: string;
  progressLabel: {
    title: string;
    icon: string;
    remainingTime: string;
  };
  progressPercent: number;
}[];
export const defaultArgs = {};
